module.exports = __webpack_public_path__ + "img/Printer.7baf8a4e.svg";